import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import CancelRounded from '@material-ui/icons/CancelRounded';
import ReplayRounded from '@material-ui/icons/ReplayRounded';
import { guc } from '../../../services/Localisation';
import styles from './styles';
import { merge, isEmptyString } from '../../../utils';
import Network from '../../../services/Network';
import { GrowTransition, handleNetworkError } from '../../utils';

export default class ImageUploadFragment extends React.Component {

    state = {
        loading: false,
        error: false,
        src: ''
    };

    uploadFile = () => {
        const formData = new FormData();
        formData.append('file', this.props.file);
        this.setState({ loading: true, error: false }, () => Network.POST(this.props.uploadApi, null, formData, { formData: true },
            response => this.setState({ loading: false, error: false }, () => this.props.onSuccess(response.image_url)),
            error => this.setState({ loading: false, error: true }, () => handleNetworkError(error))
        ));
    };

    convertFiletoSrc = () => this.setState({ src: URL.createObjectURL(this.props.file) });

    componentDidMount = () => {
        if (isEmptyString(this.props.url)) {
            this.uploadFile();
            this.convertFiletoSrc();
        }
    }

    getSrc = () => !isEmptyString(this.props.url) ? this.props.url : (!isEmptyString(this.state.src) ? this.state.src : '');

    render = () => {
        const { style, file, onSuccess, onDelete, uploadApi, ...props } = this.props;
        return <div style={merge(styles.container, style)} {...props}>
            {this.state.loading && <div style={styles.loader}><CircularProgress /></div>}
            {this.state.error && <Tooltip title={guc('upload_failed_click')} TransitionComponent={GrowTransition}><ReplayRounded style={styles.retry} onClick={this.uploadFile} /></Tooltip>}
            <CancelRounded style={styles.delete} onClick={onDelete} />
            <img src={this.getSrc()} alt='uploaded_image' style={styles.image} />
        </div>;
    }

}